import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  d: "M12.7 7.95a.7.7 0 1 0-1.4 0v5.4a.7.7 0 1 0 1.4 0zm-.596 7.656L12 15.6l-.098.005A.899.899 0 0 0 12 17.4a.9.9 0 0 0 .103-1.794"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.277 3.744A2.54 2.54 0 0 1 9.072 3h5.854c.674 0 1.32.268 1.796.744l3.533 3.533c.477.477.745 1.124.745 1.798v5.852a2.54 2.54 0 0 1-.742 1.793l-3.535 3.536a2.54 2.54 0 0 1-1.796.744H9.072a2.54 2.54 0 0 1-1.794-.743l-3.534-3.534A2.54 2.54 0 0 1 3 14.927V9.072c0-.673.268-1.319.743-1.794zM12 7.25a.7.7 0 0 1 .7.7v5.4a.7.7 0 1 1-1.4 0v-5.4a.7.7 0 0 1 .7-.7m0 8.35.104.006a.9.9 0 1 1-.203 0z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=AlertErrorFilledIcon24.js.map